import { createFileRoute, redirect } from '@tanstack/react-router';

import { AdminChat } from '@/pages/admin/chat/AdminChat';

export const Route = createFileRoute('/admin/_admin/chat')({
  beforeLoad: ({ context }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: '/'
      });
    }
  },
  component: AdminChat
});
